import { MonoTypeOperatorFunction, Observable, of, throttleTime, zip } from 'rxjs';

export class ObservableHelper {
	/**
	 * https://www.learnrxjs.io/operators/combination/zip.html
	 * @param observables Observables to zip
	 */
	zipObservables(observables: readonly Observable<any>[]): Observable<any> {
		if (observables.length === 0) {
			return of(undefined);
		}

		if (observables.length === 1) {
			return observables[0];
		}

		let zippedObservable: Observable<any> = observables[0];

		for (let i = 1; i < observables.length; i++) {
			const currentObservable = observables[i];
			zippedObservable = zip(zippedObservable, currentObservable);
		}

		return zippedObservable;
	}

	/**
	 * Custom debounce handler
	 * It fires event as soon as possible, throttles events in between and emits last value
	 */
	customDebounceTime<T>(ms: number = 1000): MonoTypeOperatorFunction<T> {
		return throttleTime<T>(ms, undefined, {
			trailing: true,
			leading: true
		});
	}

	saveDebounceTime<T>(data: { readonly isMobileView: boolean }): MonoTypeOperatorFunction<T> {
		// Use longer debounce time for mobiles
		return throttleTime<T>(data.isMobileView ? 1600 : 1100, undefined, {
			trailing: true,
			leading: true
		});
	}

	notificationDebounceTime<T>(): MonoTypeOperatorFunction<T> {
		return throttleTime<T>(2000, undefined, {
			trailing: true,
			leading: true
		});
	}

	screenSizeDebounceTime<T>(): MonoTypeOperatorFunction<T> {
		return throttleTime<T>(100, undefined, {
			trailing: true,
			leading: true
		});
	}
}

export const observableHelper = new ObservableHelper();
